<div class="new-target-choice-container">
    <p>{{ prompt }}</p>
    <div class="new-target-options">
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/plus-outline.svg"
            class="new-target-option new-target-option-account"
            [ngClass]="{ selected: selectedOption === 'ACCOUNT' }"
            (buttonClick)="onChoose('ACCOUNT')"
        >
            {{ accountOptionLabel }}
        </ham-button>
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/duplicate-folders.svg"
            class="new-target-option new-target-option-group"
            [ngClass]="{ selected: selectedOption === 'GROUP' }"
            (buttonClick)="onChoose('GROUP')"
        >
            {{ groupOptionLabel }}
        </ham-button>
    </div>
</div>
